import { useEffect, useState } from 'react';

import TextField from 'honeydew/TextField';

function EBTPaymentElement({
    className,
    defaultAmount,
    error,
    id = 'ebt-payment-element',
    label = 'Payment Amount',
    onChange,
    ...restProps
}) {
    const [amount, setAmount] = useState(defaultAmount || '');

    const handleChange = (e) => {
        const inputValue = e.target.value;

        // Allow empty input or valid decimal with max 2 decimal places
        if (inputValue === '' || /^\d*\.?\d{0,2}$/.test(inputValue)) {
            setAmount(inputValue);
            onChange?.(inputValue);
        }
    };

    // Update amount when defaultAmount prop changes
    useEffect(() => {
        if (defaultAmount !== undefined && defaultAmount !== amount) {
            setAmount(defaultAmount);
        }
    }, [defaultAmount]);

    return (
        <div className={className} data-testid="ebt-payment-element">
            <TextField
                label={`${label} *`}
                id={id}
                inputProps={{ inputMode: 'decimal' }}
                value={amount}
                onChange={handleChange}
                type="number"
                hoverWhite
                {...restProps}
            />
            {error && <p className="text-body-xs mt-10 text-error">{error}</p>}
        </div>
    );
}

export default EBTPaymentElement;
